<template>
  <router-view v-slot="{ Component }">
    <at-sidebar
      :items="items"
      :logo="{
        name: 'Merchant Logo',
        path: '/Logo.svg',
        darkPath: '/LogoDark.svg',
      }"
      :module="module"
      :modules="moduleOptions"
      @update:module="changeModule"
    >
      <template #user-section>
        <profile-settings />
      </template>

      <template #default>
        <div class="pb-12 -m-6">
          <component :is="Component"></component>
        </div>
      </template>
    </at-sidebar>
  </router-view>

  <reload-page-on-deploy-modal />
</template>

<script setup>
  import { computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { ACQUIRING_ROUTE_NAMES } from '@/to-fsd/shared/router';
  import { useUserStore } from '@/to-fsd/shared/store/user';
  import { useMainStore } from '@/to-fsd/shared/store/main';
  import { storeToRefs } from 'pinia';
  import { useModuleOptions } from '@/to-fsd/shared/hooks';
  import { useJivoFieldsAutoComplete } from '@/to-fsd/features/jivo';
  import { ReloadPageOnDeployModal } from '@/to-fsd/features/reload-page-on-deploy';
  import { AtSidebar } from '@packages/aliftech-ui';
  import { modulesList, modulesName } from '@/to-fsd/shared/constants';
  import { ProfileSettings } from '@/to-fsd/widgets/profile-settings';

  useJivoFieldsAutoComplete();

  const { t } = useI18n();
  const router = useRouter();

  const user = useUserStore();
  const store = useMainStore();
  const { module } = storeToRefs(store);
  const moduleOptions = useModuleOptions();
  store.$patch({ module: modulesName.ACQUIRING });

  const links = computed(() => {
    return [
      {
        title: t('layouts.acquring.balances'),
        visible: true,
        icon: 'CurrencyDollar',
        to: { name: ACQUIRING_ROUTE_NAMES.balancesList },
      },
      {
        title: t('layouts.acquring.scoring'),
        visible: true,
        permission: 'merchant_scoring_card',
        icon: 'CreditCard',
        to: { name: ACQUIRING_ROUTE_NAMES.cardScoring },
      },
      {
        title: t('layouts.acquring.searchClients'),
        visible: true,
        icon: 'Search',
        to: { name: ACQUIRING_ROUTE_NAMES.searchClients },
      },
    ];
  });

  const items = computed(() => {
    const permissionNames = user.me?.resource_access.merchant.roles || [];

    return links.value?.filter?.(link => {
      return (link.visible && permissionNames.find?.(el => el === link.permission || !link.permission)) || false;
    });
  });

  const changeModule = value => {
    store.$patch({ module: value });
    router.push({ name: modulesList[value].homeRoute });
  };
</script>
